/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightDownIcon16Regular = forwardRef('ArrowDCornerRightDownIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7 2.75c.69 0 1.25.56 1.25 1.25v7.94L5.03 8.72a.75.75 0 0 0-1.06 1.06l3.651 3.652a1.95 1.95 0 0 0 2.758 0L14.03 9.78a.75.75 0 0 0-1.06-1.06l-3.22 3.22V4A2.75 2.75 0 0 0 7 1.25H.75a.75.75 0 0 0 0 1.5H7Z" })));
});
